module.exports = __webpack_public_path__ + "static/media/fairy.598d8aab.svg";